"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__cache = new Map();
function cacheGet(key) {
    return exports.__cache.get(key);
}
exports.cacheGet = cacheGet;
function cacheSet(key, value) {
    return exports.__cache.set(key, value);
}
exports.cacheSet = cacheSet;
function cacheClear() {
    exports.__cache.clear();
}
exports.cacheClear = cacheClear;
function cacheView() {
    var cacheObj = {};
    exports.__cache.forEach(function (value, key) { return (cacheObj[key] = value); });
    return cacheObj;
}
exports.cacheView = cacheView;
//# sourceMappingURL=cache.js.map